import React from "react";
import { Nav, useThemeName, useViewportSizeName } from "thorium-ui";

export const ProjectNav = (props) => {
   const vpSizeName = useViewportSizeName();
   const themeName = useThemeName();
   return (
      <Nav
         xs={12}
         sm={12}
         md={10}
         lg={10}
         xl={8}
         vertical={["xs", "sm"].includes(vpSizeName)}
         variant={themeName === "dark" ? "light" : "dark"}
         trackActive
         className="project-nav animate fade slideY"
         defaultActive="all"
         onActiveItemChange={(data) => props.onChange(data)}
      >
         <Nav.Item navkey="all">All</Nav.Item>
         <Nav.Item navkey="react">React.js</Nav.Item>
         <Nav.Item navkey="typescript">TypeScript</Nav.Item>
         <Nav.Item navkey="python">Python</Nav.Item>
      </Nav>
   );
};

export default ProjectNav;
